import Navbar from "./components/Navbar";
import Hero from "./components/sections/Hero";
import Services from "./components/sections/Services";
import Projects from "./components/sections/Projects";
import Skills from "./components/sections/Skills";
import Approach from "./components/sections/Approach";
import About from "./components/sections/About";
import Contact from "./components/sections/Contact";
import Footer from "./components/Footer";
import "./App.css";

function App() {
  return (
    <div className="site-shell">
      <a className="skip-link" href="#main-content">
        Skip to content
      </a>
      <Navbar />
      <main id="main-content">
        <Hero />
        <Services />
        <Projects />
        <Approach />
        <Skills />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
